import { compose, lifecycle, withState, withHandlers } from 'recompose';

export const getViewportSize = () => window.getComputedStyle(
  document.querySelector('body'), ':before',
).getPropertyValue('content').replace(/"/g, '');

const withViewportSize = compose(
  withState('viewportSize', 'setViewportSize', getViewportSize()),
  withHandlers({
    updateViewportSize: ({ setViewportSize, viewportSize }) => () => {
      const currentViewportSize = getViewportSize();
      return currentViewportSize !== viewportSize && setViewportSize(currentViewportSize);
    },
  }),
  lifecycle({
    componentDidMount() {
      window.addEventListener('resize', this.props.updateViewportSize);
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.updateViewportSize);
    },
  }),
);

export default withViewportSize;



// WEBPACK FOOTER //
// ./src/hoc/withViewportSize.js